/**
 * Carousel
 * https://swiperjs.com/
 */



// import Swiper from 'Vendor/swiper.js';
// import $ from "jquery";

import Swiper, { Navigation, Pagination } from 'swiper';

let swiperJaSlider = undefined;

export default function jaTeaserSlider() {

  // When Carousel exists
  if (jaTeaserSlider) {
    let $obj = $('.ja-teaser-slider');

    function initTeaserSlider() {
      let $obj = $('.ja-teaser-slider');

      const swiperCarousels = document.querySelectorAll(".ja-teaser-swiper");

      swiperCarousels.forEach(carouselContainer => {
        let $this = $(carouselContainer);


        const carouselPagination = carouselContainer.querySelector(
            ".swiper-pagination"
        );

        const carouselPrevButton =
            carouselContainer.querySelector(".swiper-button-prev") ||
            carouselContainer.parentElement.querySelector(
                ".swiper-button-prev" // <-- this is how you can have the Prev Button outside the swiper container
            );

        const carouselNextButton =
            carouselContainer.querySelector(".swiper-button-next") ||
            carouselContainer.parentElement.querySelector(
                ".swiper-button-next" // <-- this is how you can have the Next Button outside the swiper container
            );

        if (!$this.hasClass('swiper-horizontal')) {
          swiperJaSlider = new Swiper(carouselContainer, {
            modules: [Navigation, Pagination],
            loop: true,
            speed: 500,
            spaceBetween: 15,
            centeredSlides: true,
            slideToClickedSlide: true,
            slidesPerView: "auto",
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 10,
            },
            navigation: {
              nextEl: carouselNextButton,
              prevEl: carouselPrevButton
            },
            pagination: {
              el: carouselPagination,
              clickable: true,
              dynamicBullets: true
            },
            breakpoints: {
              768: {
                // slidesPerView: 'auto',
                // slidesPerGroup: 1,
                // centeredSlides: true,
                // spaceBetween: 10,
                // loop: true,
                // noSwiping: false
              },
              991: {
                slidesPerView: "auto",
                slidesPerGroup: 1,
                spaceBetween: 10,
                centeredSlides: false
              }
            }
          });
        }
      });
    }

    initTeaserSlider()
  }

}
